<script setup lang="ts">
interface Props {
	size?: string;
}
defineProps<Props>();
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="size ?? '24'"
		:height="size ?? '24'"
		fill="none"
	>
		<path
			d="M12.6669 0.000244141C9.40786 0.000244141 8.99885 0.0144944 7.71884 0.0727444C6.44133 0.131244 5.56932 0.333494 4.80631 0.630244C4.01705 0.936744 3.34754 1.34674 2.68054 2.01399C2.01303 2.68099 1.60303 3.35049 1.29552 4.13949C0.998019 4.90274 0.795517 5.77499 0.738016 7.05199C0.681016 8.332 0.666016 8.74124 0.666016 12.0002C0.666016 15.2592 0.680516 15.667 0.738517 16.947C0.797267 18.2245 0.999519 19.0965 1.29602 19.8595C1.60278 20.6487 2.01278 21.3182 2.68004 21.9852C3.34679 22.6527 4.0163 23.0637 4.80506 23.3702C5.56857 23.667 6.44083 23.8692 7.71809 23.9277C8.9981 23.986 9.40686 24.0002 12.6656 24.0002C15.9249 24.0002 16.3327 23.986 17.6127 23.9277C18.8902 23.8692 19.7632 23.667 20.5267 23.3702C21.3157 23.0637 21.9842 22.6527 22.651 21.9852C23.3185 21.3182 23.7285 20.6487 24.036 19.8597C24.331 19.0965 24.5335 18.2242 24.5935 16.9472C24.651 15.6672 24.666 15.2592 24.666 12.0002C24.666 8.74124 24.651 8.33224 24.5935 7.05224C24.5335 5.77474 24.331 4.90274 24.036 4.13974C23.7285 3.35049 23.3185 2.68099 22.651 2.01399C21.9835 1.34649 21.316 0.936494 20.526 0.630244C19.761 0.333494 18.8885 0.131244 17.6109 0.0727444C16.3309 0.0144944 15.9234 0.000244141 12.6634 0.000244141H12.6669ZM11.5904 2.16274C11.9099 2.16224 12.2664 2.16274 12.6669 2.16274C15.8709 2.16274 16.2507 2.17424 17.5159 2.23174C18.686 2.28524 19.321 2.48074 19.744 2.64499C20.304 2.86249 20.7032 3.12249 21.123 3.54249C21.543 3.96249 21.803 4.36249 22.021 4.92249C22.1852 5.34499 22.381 5.97999 22.4342 7.14999C22.4917 8.41499 22.5042 8.79499 22.5042 11.9975C22.5042 15.2 22.4917 15.58 22.4342 16.845C22.3807 18.015 22.1852 18.65 22.021 19.0725C21.8035 19.6325 21.543 20.0312 21.123 20.451C20.703 20.871 20.3042 21.131 19.744 21.3485C19.3215 21.5135 18.686 21.7085 17.5159 21.762C16.2509 21.8195 15.8709 21.832 12.6669 21.832C9.46261 21.832 9.08285 21.8195 7.81784 21.762C6.64783 21.708 6.01282 21.5125 5.58957 21.3482C5.02956 21.1307 4.62956 20.8707 4.20955 20.4507C3.78955 20.0307 3.52955 19.6317 3.31154 19.0715C3.14729 18.649 2.95154 18.014 2.89829 16.844C2.84079 15.579 2.82929 15.199 2.82929 11.9945C2.82929 8.78999 2.84079 8.41199 2.89829 7.147C2.95179 5.97699 3.14729 5.34199 3.31154 4.91899C3.52905 4.35899 3.78955 3.95899 4.20955 3.53899C4.62956 3.11899 5.02956 2.85899 5.58957 2.64099C6.01257 2.47599 6.64783 2.28099 7.81784 2.22724C8.92485 2.17724 9.35386 2.16224 11.5904 2.15974V2.16274Z"
			fill="url(#paint0_radial_3618_19704)"
		/>
		<path
			d="M19.0467 4.12577C18.7618 4.12577 18.4834 4.21023 18.2466 4.36849C18.0098 4.52674 17.8252 4.75166 17.7162 5.01482C17.6072 5.27797 17.5787 5.56753 17.6343 5.84688C17.6899 6.12623 17.8271 6.38281 18.0286 6.58418C18.23 6.78555 18.4867 6.92265 18.766 6.97816C19.0454 7.03367 19.3349 7.00508 19.5981 6.89601C19.8612 6.78694 20.0861 6.6023 20.2442 6.36542C20.4024 6.12855 20.4868 5.85009 20.4867 5.56527C20.4867 4.77027 19.8417 4.12527 19.0467 4.12527V4.12577Z"
			fill="url(#paint1_radial_3618_19704)"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.6411 5.80827C9.2378 5.80827 6.47852 8.56752 6.47852 11.9708C6.47852 15.374 9.2378 18.132 12.6411 18.132C16.0444 18.132 18.8029 15.374 18.8029 11.9708C18.8029 8.56752 16.0444 5.80827 12.6411 5.80827ZM12.666 15.9378C14.8406 15.9378 16.6035 14.1749 16.6035 12.0003C16.6035 9.82565 14.8406 8.06277 12.666 8.06277C10.4914 8.06277 8.72852 9.82565 8.72852 12.0003C8.72852 14.1749 10.4914 15.9378 12.666 15.9378Z"
			fill="url(#paint2_radial_3618_19704)"
		/>
		<path
			d="M12.6669 0.000244141C9.40786 0.000244141 8.99885 0.0144944 7.71884 0.0727444C6.44133 0.131244 5.56932 0.333494 4.80631 0.630244C4.01705 0.936744 3.34754 1.34674 2.68054 2.01399C2.01303 2.68099 1.60303 3.35049 1.29552 4.13949C0.998019 4.90274 0.795517 5.77499 0.738016 7.05199C0.681016 8.332 0.666016 8.74124 0.666016 12.0002C0.666016 15.2592 0.680516 15.667 0.738517 16.947C0.797267 18.2245 0.999519 19.0965 1.29602 19.8595C1.60278 20.6487 2.01278 21.3182 2.68004 21.9852C3.34679 22.6527 4.0163 23.0637 4.80506 23.3702C5.56857 23.667 6.44083 23.8692 7.71809 23.9277C8.9981 23.986 9.40686 24.0002 12.6656 24.0002C15.9249 24.0002 16.3327 23.986 17.6127 23.9277C18.8902 23.8692 19.7632 23.667 20.5267 23.3702C21.3157 23.0637 21.9842 22.6527 22.651 21.9852C23.3185 21.3182 23.7285 20.6487 24.036 19.8597C24.331 19.0965 24.5335 18.2242 24.5935 16.9472C24.651 15.6672 24.666 15.2592 24.666 12.0002C24.666 8.74124 24.651 8.33224 24.5935 7.05224C24.5335 5.77474 24.331 4.90274 24.036 4.13974C23.7285 3.35049 23.3185 2.68099 22.651 2.01399C21.9835 1.34649 21.316 0.936494 20.526 0.630244C19.761 0.333494 18.8885 0.131244 17.6109 0.0727444C16.3309 0.0144944 15.9234 0.000244141 12.6634 0.000244141H12.6669ZM11.5904 2.16274C11.9099 2.16224 12.2664 2.16274 12.6669 2.16274C15.8709 2.16274 16.2507 2.17424 17.5159 2.23174C18.686 2.28524 19.321 2.48074 19.744 2.64499C20.304 2.86249 20.7032 3.12249 21.123 3.54249C21.543 3.96249 21.803 4.36249 22.021 4.92249C22.1852 5.34499 22.381 5.97999 22.4342 7.14999C22.4917 8.41499 22.5042 8.79499 22.5042 11.9975C22.5042 15.2 22.4917 15.58 22.4342 16.845C22.3807 18.015 22.1852 18.65 22.021 19.0725C21.8035 19.6325 21.543 20.0312 21.123 20.451C20.703 20.871 20.3042 21.131 19.744 21.3485C19.3215 21.5135 18.686 21.7085 17.5159 21.762C16.2509 21.8195 15.8709 21.832 12.6669 21.832C9.46261 21.832 9.08285 21.8195 7.81784 21.762C6.64783 21.708 6.01282 21.5125 5.58957 21.3482C5.02956 21.1307 4.62956 20.8707 4.20955 20.4507C3.78955 20.0307 3.52955 19.6317 3.31154 19.0715C3.14729 18.649 2.95154 18.014 2.89829 16.844C2.84079 15.579 2.82929 15.199 2.82929 11.9945C2.82929 8.78999 2.84079 8.41199 2.89829 7.147C2.95179 5.97699 3.14729 5.34199 3.31154 4.91899C3.52905 4.35899 3.78955 3.95899 4.20955 3.53899C4.62956 3.11899 5.02956 2.85899 5.58957 2.64099C6.01257 2.47599 6.64783 2.28099 7.81784 2.22724C8.92485 2.17724 9.35386 2.16224 11.5904 2.15974V2.16274Z"
			fill="url(#paint3_radial_3618_19704)"
		/>
		<path
			d="M19.0467 4.12577C18.7618 4.12577 18.4834 4.21023 18.2466 4.36849C18.0098 4.52674 17.8252 4.75166 17.7162 5.01482C17.6072 5.27797 17.5787 5.56753 17.6343 5.84688C17.6899 6.12623 17.8271 6.38281 18.0286 6.58418C18.23 6.78555 18.4867 6.92265 18.766 6.97816C19.0454 7.03367 19.3349 7.00508 19.5981 6.89601C19.8612 6.78694 20.0861 6.6023 20.2442 6.36542C20.4024 6.12855 20.4868 5.85009 20.4867 5.56527C20.4867 4.77027 19.8417 4.12527 19.0467 4.12527V4.12577Z"
			fill="url(#paint4_radial_3618_19704)"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.6411 5.80827C9.2378 5.80827 6.47852 8.56752 6.47852 11.9708C6.47852 15.374 9.2378 18.132 12.6411 18.132C16.0444 18.132 18.8029 15.374 18.8029 11.9708C18.8029 8.56752 16.0444 5.80827 12.6411 5.80827ZM12.666 15.9378C14.8406 15.9378 16.6035 14.1749 16.6035 12.0003C16.6035 9.82565 14.8406 8.06277 12.666 8.06277C10.4914 8.06277 8.72852 9.82565 8.72852 12.0003C8.72852 14.1749 10.4914 15.9378 12.666 15.9378Z"
			fill="url(#paint5_radial_3618_19704)"
		/>
		<defs>
			<radialGradient
				id="paint0_radial_3618_19704"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(7.04105 25.8487) rotate(-90) scale(23.7858 22.1226)"
			>
				<stop stop-color="#FFDD55" />
				<stop offset="0.1" stop-color="#FFDD55" />
				<stop offset="0.5" stop-color="#FF543E" />
				<stop offset="1" stop-color="#C837AB" />
			</radialGradient>
			<radialGradient
				id="paint1_radial_3618_19704"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(7.04105 25.8487) rotate(-90) scale(23.7858 22.1226)"
			>
				<stop stop-color="#FFDD55" />
				<stop offset="0.1" stop-color="#FFDD55" />
				<stop offset="0.5" stop-color="#FF543E" />
				<stop offset="1" stop-color="#C837AB" />
			</radialGradient>
			<radialGradient
				id="paint2_radial_3618_19704"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(7.04105 25.8487) rotate(-90) scale(23.7858 22.1226)"
			>
				<stop stop-color="#FFDD55" />
				<stop offset="0.1" stop-color="#FFDD55" />
				<stop offset="0.5" stop-color="#FF543E" />
				<stop offset="1" stop-color="#C837AB" />
			</radialGradient>
			<radialGradient
				id="paint3_radial_3618_19704"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-3.35411 1.72916) rotate(78.6806) scale(10.6323 43.827)"
			>
				<stop stop-color="#3771C8" />
				<stop offset="0.128" stop-color="#3771C8" />
				<stop offset="1" stop-color="#6600FF" stop-opacity="0" />
			</radialGradient>
			<radialGradient
				id="paint4_radial_3618_19704"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-3.35411 1.72916) rotate(78.6806) scale(10.6323 43.827)"
			>
				<stop stop-color="#3771C8" />
				<stop offset="0.128" stop-color="#3771C8" />
				<stop offset="1" stop-color="#6600FF" stop-opacity="0" />
			</radialGradient>
			<radialGradient
				id="paint5_radial_3618_19704"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-3.35411 1.72916) rotate(78.6806) scale(10.6323 43.827)"
			>
				<stop stop-color="#3771C8" />
				<stop offset="0.128" stop-color="#3771C8" />
				<stop offset="1" stop-color="#6600FF" stop-opacity="0" />
			</radialGradient>
		</defs>
	</svg>
</template>
